function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import GroupHeader from "./group-header";
import GroupItems from "./group-items";
import SocialMediaLinks from "../specific/social-media-links";
var Group = function Group(_ref) {
  var group = _ref.group,
    index = _ref.index,
    language = _ref.language,
    isMobile = _ref.isMobile,
    dictionary = _ref.dictionary;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showGroupItems = _useState2[0],
    setShowGroupItems = _useState2[1];
  var handleGroupOnMobileHeaderClick = function handleGroupOnMobileHeaderClick(e) {
    e.preventDefault();
    setShowGroupItems(function (show) {
      return !show;
    });
  };
  var items = group.items.filter(function (item) {
    return item.tag !== "socialMediaLink" && item.tag !== null;
  });
  return /*#__PURE__*/React.createElement("li", {
    className: "footer__group ".concat(group.tags[0], " ").concat(showGroupItems && isMobile ? "active" : "", " ").concat(items.length === 1 ? "no-accordion" : "")
  }, isMobile && !group.tags.includes("selectCountryGroup") && items.length > 1 && /*#__PURE__*/React.createElement(GroupHeader, {
    item: group.taggedItems.groupHeader[0],
    handleGroupOnHeaderClick: handleGroupOnMobileHeaderClick,
    showGroupItems: showGroupItems,
    groupIndex: index
  }), /*#__PURE__*/React.createElement(GroupItems, {
    groupIndex: index,
    items: items,
    language: language,
    isMobile: isMobile,
    showMoreLabel: dictionary.Common.more,
    homePageLabel: dictionary.Common.home,
    showGroupItems: items.length > 1 ? showGroupItems : true
  }), group.taggedItems.socialMediaLink !== undefined && /*#__PURE__*/React.createElement(SocialMediaLinks, {
    links: group.taggedItems.socialMediaLink
  }));
};
export default Group;